import { FileDetails, FilePickerOptions } from "@interface48/form-controls";
import React from "react";
import { getErrors } from "../utils";
import { FileField as FileFieldHelper } from "./helpers";
import { FieldProps, FileFormData } from "./models";

export const toFileDetails = (formData: FileFormData): FileDetails | undefined => {
  const fileDetails =
    formData.fileName && formData.fileSizeBytes != null
      ? {
          fileName: formData.fileName,
          fileSizeBytes: formData.fileSizeBytes,
        }
      : undefined;

  return fileDetails;
};

interface FileFieldOptions extends FilePickerOptions {
  readOnly?: boolean;
}

interface FileFieldProps extends FieldProps<FileFormData> {}

export const FileFieldComponent = (props: FileFieldProps) => {
  const { idSchema, schema, uiSchema, errorSchema, required, formData, formContext, onChange } = props;
  const options = uiSchema["ui:options"] as FileFieldOptions | undefined;
  const help = uiSchema["ui:help"] as string | undefined;

  if (!options) {
    throw Error("ui:options not found on FileField.");
  } else if (!options.uploadUrl) {
    throw Error("uploadUrl must be specified on ui:options.");
  }

  const { readOnly = false, ...restOptions } = options;

  const id = idSchema.$id;
  const label = schema.title;
  const errors = getErrors(schema, errorSchema);

  const fileDetails = toFileDetails(formData);

  const handleChange = (fileUploadId: string, fileDetails: { fileName: string; fileSizeBytes: number }) => {
    const nextFileFormData: FileFormData = {
      fileUploadId,
      fileName: (fileDetails && fileDetails.fileName) || undefined,
      fileSizeBytes: (fileDetails && fileDetails.fileSizeBytes) || undefined,
    };
    onChange(nextFileFormData);
  };

  const handleBlur = () => {
    const { required, formData, onChange } = props;
    // If required, and fileUploadId is undefined, set fileUploadId to null to propagate a
    // "Field is required" error...
    if (required && formData.fileUploadId === undefined) {
      const nextFormData = { ...formData, fileUploadId: null };

      onChange(nextFormData);
    }
  };

  return (
    <FileFieldHelper
      id={id}
      label={label}
      required={required}
      readOnly={readOnly}
      fileDetails={fileDetails}
      options={restOptions}
      help={help}
      errors={errors}
      getApiConfiguration={formContext.getApiConfiguration}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export const FileField = FileFieldComponent;
